import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { FaArrowRight, FaLongArrowAltRight } from "react-icons/fa";

import ladohotel from "../../assets/imagens/sobre/frentehotel4.png";
import recepcao from "../../assets/imagens/sobre/recpmenor.jpg";
import sofa from "../../assets/imagens/sobre/sobre (1).jpeg";
import cafe from "../../assets/imagens/sobre/sobre (2).jpeg";
import quarto from "../../assets/imagens/sobre/sobre (3).jpeg";
import { COMODIDADES } from "./comodidadesData";
import "./style.css";

const mosaicItems = [
  { src: recepcao, alt: "Recepção do hotel" },
  { src: sofa, alt: "Espaço de convivência" },
  { src: cafe, alt: "Café da manhã" },
  { src: quarto, alt: "Detalhe de acomodação" },
];

const Estrutura = () => {
  return (
    <article className="estrutura-shell">
      <header className="estrutura-hero">
        <Container className="estrutura-hero__container">
          <Row className="estrutura-hero__row align-items-center gx-lg-5 gx-xl-5">
            <Col lg={6} className="order-2 order-lg-1 estrutura-hero__col-visual">
              <div className="estrutura-hero__figure">
                <div className="estrutura-hero__visual-inner">
                  <img
                    src={ladohotel}
                    alt="Fachada e entrada do Hotel Marechal Express"
                    className="estrutura-hero__img"
                    decoding="async"
                  />
                </div>
              </div>
            </Col>
            <Col lg={6} className="order-1 order-lg-2 estrutura-hero__col-copy">
              <div className="estrutura-hero__copy">
                <p className="estrutura-hero__eyebrow">Nossa estrutura</p>
                <h1 className="estrutura-hero__title">
                  Onde cada detalhe{" "}
                  <span className="estrutura-hero__title-accent">acolhe com cuidado</span>
                </h1>
                <p className="estrutura-hero__lead">
                  Ambientes pensados para o descanso, o encontro e o bom atendimento — sem pressa,
                  com a clareza que você merece desde a chegada.
                </p>
                <ul className="estrutura-hero__tags">
                  <li>Recepção 24h</li>
                  <li>Café incluso</li>
                  <li>Áreas comuns</li>
                  <li>Garagem fechada · 24h</li>
                </ul>
                <a href="#areas" className="estrutura-hero__scroll">
                  Conhecer as áreas
                  <FaLongArrowAltRight className="estrutura-hero__scroll-icon" aria-hidden />
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="estrutura-prelude" aria-labelledby="estrutura-prelude-heading">
        <Container>
          <Row className="g-4 g-lg-5 align-items-center">
            <Col lg={5} data-aos="fade-right">
              <h2 id="estrutura-prelude-heading" className="estrutura-prelude__heading">
                Hospitalidade com transparência
              </h2>
              <p className="estrutura-prelude__text">
                Preferimos mostrar o hotel como ele é: acolhedor, funcional e transparente nas
                informações — da recepção 24 horas à garagem fechada com portão eletrônico e área
                parcialmente coberta. Abaixo, um panorama das áreas que complementam sua estadia;
                cada uma abre em uma página dedicada, com texto e imagens reunidos com calma.
              </p>
              <p className="estrutura-prelude__quote" role="note">
                <span className="estrutura-prelude__quote-mark" aria-hidden>
                  “
                </span>
                Aqui o silêncio da noite e o café da manhã no salão fazem parte da mesma promessa: o seu
                bem-estar.
              </p>
            </Col>
            <Col lg={7} data-aos="fade-left">
              <div className="estrutura-mosaic">
                {mosaicItems.map((item) => (
                  <figure key={item.alt} className="estrutura-mosaic__cell">
                    <img src={item.src} alt={item.alt} loading="lazy" />
                  </figure>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section id="areas" className="estrutura-areas">
        <Container>
          <div className="estrutura-areas__intro text-center" data-aos="fade-up">
            <p className="section-eyebrow">Quatro experiências</p>
            <h2 className="section-heading text-center d-inline-block mb-2">Áreas que completam a estadia</h2>
            <p className="estrutura-areas__sub text-muted mx-auto mb-0">
              Imagens fixas e leitura tranquila — sem carrosséis. Toque ou clique para aprofundar.
            </p>
          </div>

          <div className="estrutura-areas__list">
            {COMODIDADES.map((area, index) => {
              const capa = area.imagens[0];
              const extra = area.imagens.slice(1, 3);
              const previewPoints = area.destaques.slice(0, 2);
              const reverse = index % 2 === 1;

              return (
                <div
                  key={area.slug}
                  className={`estrutura-area${reverse ? " estrutura-area--reverse" : ""}`}
                  data-aos="fade-up"
                  data-aos-delay={index * 40}
                >
                  <Row className="g-4 g-xl-5 align-items-center">
                    <Col lg={6} xl={6}>
                      <Link
                        to={`/estrutura/${area.slug}`}
                        className="estrutura-area__visual"
                        aria-label={`Abrir página: ${area.titulo}`}
                      >
                        <div className="estrutura-area__figure">
                          <img
                            src={capa}
                            alt={`${area.titulo} — vista principal`}
                            className="estrutura-area__img-main"
                            decoding="async"
                          />
                          {extra.length > 0 && (
                            <div className="estrutura-area__thumbs">
                              {extra.map((thumb, i) => (
                                <div key={i} className="estrutura-area__thumb">
                                  <img
                                    src={thumb}
                                    alt={`${area.titulo} — complemento ${i + 1}`}
                                    loading="lazy"
                                  />
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </Link>
                    </Col>
                    <Col lg={6} xl={6}>
                      <div className="estrutura-area__content">
                        <span className="estrutura-area__index" aria-hidden>
                          {String(index + 1).padStart(2, "0")}
                        </span>
                        <h3 className="estrutura-area__title font-display">{area.titulo}</h3>
                        <p className="estrutura-area__resumo">{area.resumo}</p>
                        <ul className="estrutura-area__points">
                          {previewPoints.map((pt) => (
                            <li key={pt}>{pt}</li>
                          ))}
                        </ul>
                        <Link to={`/estrutura/${area.slug}`} className="estrutura-area__link">
                          Explorar em detalhe
                          <FaArrowRight className="estrutura-area__link-icon" aria-hidden />
                        </Link>
                      </div>
                    </Col>
                  </Row>
                </div>
              );
            })}
          </div>
        </Container>
      </section>

      <section className="estrutura-outro">
        <Container>
          <div className="estrutura-outro__card" data-aos="fade-up">
            <Row className="align-items-center g-4">
              <Col md>
                <p className="estrutura-outro__eyebrow">Próximo passo</p>
                <h2 className="estrutura-outro__title font-display mb-0">
                  Os quartos onde você vai repousar
                </h2>
                <p className="estrutura-outro__text text-muted mb-0 mt-2">
                  Tipos de acomodação, fotos e tour virtual — tudo na mesma linha estética do hotel.
                </p>
              </Col>
              <Col md="auto">
                <Link to="/acomodações" className="btn btn-hotel-primary estrutura-outro__btn">
                  Ver acomodações
                  <FaArrowRight className="ms-2" aria-hidden />
                </Link>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
    </article>
  );
};

export default Estrutura;
